import React from 'react';
import classNames from 'classnames';
import clickOutside from 'react-click-outside';


@clickOutside
export default class FilterCountySelect extends React.Component {
  state = {active: false, value: ''};

  handleClickOutside() {
    if(this.state.active)
      this.setState({active: false});
  }

  componentWillMount = () => {
    this.setState({value: this.props.value})
  };

  activateDropDown = () => {
    if(!this.state.active)
      this.setState({active: true})
  };

  handleSelect = e => {
    this.props.handleChange({[this.props.name]: e.target.getAttribute("value")});
    this.setState({active: false})
  };

  componentWillReceiveProps = newProps => {
    this.setState({value: newProps.value})
  };


  render(){
    return(
      <div>
        <label className="filter-item " onClick={this.activateDropDown} style={{marginBottom: 0}}>
          <input className="animate-input"
                 type="text" value={this.state.value}
                 readOnly={true}
                 />
          <span>
            <i className="ic-map-ico"/>{this.props.value}</span>
        </label>
        <ul className={classNames('animate-select-list', {'show-item-select': this.state.active} )}
             style={{height: 300,
               overflowY: 'auto'}}>
          {this.props.elements.map( (el, i) => <li key={i} onClick={this.handleSelect} className="animate-select-list-item" value={el.value}>{el.title}</li>)}
        </ul>
      </div>
        )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/FilterCountySelect.jsx